const formatCentimeters = (value: string) => {
  const formatedValue = Number(value) / 100.0;
  if (formatedValue < 1.0) {
    return `${formatedValue} cm`;
  }
  return `${formatedValue} m`;
};

export { formatCentimeters };
